import { useState, useEffect, useRef } from 'react';
import { Star, User, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
const testimonials = [
  {
    id: 1,
    name: "Satosh Mishra",
    role: "Digital Agency",
    quote: "fast loan approval in varanasi. mai chanduli se hu waha mera koi v low nhi kr paya bahot sare bank m gya lakin yaha meri manger se batt hue wo mera loan 2 week m kra di thank you CashPro Financial Services team",
    rating: 5,
  },
  {
    id: 2,
    name: "Vinod Singh",
    role: "Business Man",
    quote: "easy loan process in varanasi",
    rating: 5,
  },
  {
    id: 3,
    name: "Sidhart Srivastava",
    role: "Business Analysis",
    quote: "Best Loan Service Provide in Varanasi",
    rating: 5,
  },
  {
    id: 4,
    name: "Riya Singh",
    role: "Digital Manager",
    quote: "I had a great experiance with CashPro Financial Services  the loan process was very smooth and fast. and team guide me properly. thank you CashPro Financial Services",
    rating: 5,
  },
  {
    id: 5,
    name: "Avntika Thakur",
    role: "Accountant",
    quote: "Igot my loan throgh CashPro Financial Services  and the process was very smooth",
    rating: 5,
  },
  {
    id: 6,
    name: "Sonal Gupta",
    role: "Doctor",
    quote: "Their digital-first approach made it so easy for me to submit documents and track my application. Highly recommended for busy professionals.",
    rating: 5,
  },
  {
    id: 7,
    name: "Vikram Singh",
    role: "Entrepreneur",
    quote: "The most professional financial team I have ever worked with. No hidden charges, just pure commitment to customer success.",
    rating: 5,
  },
  {
    id: 8,
    name: "Anjali Sharma",
    role: "Marketing Manager",
    quote: "I was struggling with my home loan application until I found Payback Money Mantra. Their experts guided me through every step and got me the best interest rate.",
    rating: 5,
  },
  {
    id: 9,
    name: "Rahul Sharma",
    role: "Business Owner",
    quote: "CashPro helped me secure a business loan in record time. Their process is completely transparent and digital.",
    rating: 5,
  },
];

const extendedTestimonials = [...testimonials, ...testimonials.slice(0, 5)];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [itemsPerView, setItemsPerView] = useState(5);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const updateItemsPerView = () => {
      const width = window.innerWidth;
      if (width >= 1280) setItemsPerView(5);
      else if (width >= 1024) setItemsPerView(4);
      else if (width >= 768) setItemsPerView(3);
      else if (width >= 640) setItemsPerView(2);
      else setItemsPerView(1);
    };
    updateItemsPerView();
    window.addEventListener('resize', updateItemsPerView);
    return () => window.removeEventListener('resize', updateItemsPerView);
  }, []);
  const totalSlides = extendedTestimonials.length;
  const maxIndex = totalSlides - itemsPerView;
  useEffect(() => {
    if (!isAutoPlaying) return;
    timeoutRef.current = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = prev + 1;
        if (next > maxIndex) return 0;
        return next;
      });
    }, 4000);
    return () => clearInterval(timeoutRef.current);
  }, [isAutoPlaying, maxIndex]);
  const goToSlide = (index) => {
    setCurrentIndex(Math.min(Math.max(0, index), maxIndex));
    if (timeoutRef.current) clearInterval(timeoutRef.current);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };
  const nextSlide = () => goToSlide(currentIndex + 1);
  const prevSlide = () => goToSlide(currentIndex - 1);
  const pauseAutoPlay = () => setIsAutoPlaying(false);
  const resumeAutoPlay = () => setIsAutoPlaying(true);
  const totalPages = testimonials.length;
  return (
    <section
      className="py-16 bg-gradient-to-br from-green-50 via-white to-yellow-50 overflow-hidden"
      onMouseEnter={pauseAutoPlay}
      onMouseLeave={resumeAutoPlay}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-gradient-to-r from-green-500 to-yellow-500 text-white text-sm font-semibold rounded-full mb-3 shadow-md">
            Client Success Stories
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            What Our Customers Say
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Real stories from our valued clients across India
          </p>
        </div>
        <div className="relative">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 hidden md:flex items-center justify-center w-10 h-10 bg-white rounded-full shadow-lg hover:bg-gradient-to-r hover:from-green-500 hover:to-yellow-500 hover:text-white transition-all duration-300 hover:scale-110"
            aria-label="Previous"
          >
            <ChevronLeft size={20} className="text-gray-700 group-hover:text-white" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 hidden md:flex items-center justify-center w-10 h-10 bg-white rounded-full shadow-lg hover:bg-gradient-to-r hover:from-green-500 hover:to-yellow-500 hover:text-white transition-all duration-300 hover:scale-110"
            aria-label="Next"
          >
            <ChevronRight size={20} className="text-gray-700 group-hover:text-white" />
          </button>
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}
            >
              {extendedTestimonials.map((testimonial, idx) => (
                <div
                  key={`${testimonial.id}-${idx}`}
                  className="flex-shrink-0 px-2"
                  style={{ width: `${100 / itemsPerView}%` }}
                >
                  <div className="bg-white rounded-2xl p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-l-4 border-yellow-400 flex flex-col h-full relative">
                    <Quote size={24} className="absolute top-3 right-3 text-green-100" />
                    <div className="flex mb-3">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={14}
                          className={`fill-current ${
                            i < testimonial.rating
                              ? 'text-yellow-400'
                              : 'text-gray-200'
                          }`}
                        />
                      ))}
                    </div>
                    <p className="text-gray-600 mb-4 leading-relaxed text-sm flex-grow line-clamp-4 relative z-10">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex items-center gap-2 pt-2 border-t border-gray-100">
                      <div className="p-1.5 bg-gradient-to-r from-green-100 to-yellow-100 rounded-full group-hover:from-green-200 group-hover:to-yellow-200 transition-colors">
                        <User size={14} className="text-green-600" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-800 text-xs">{testimonial.name}</h4>
                        <p className="text-[10px] text-gray-500">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: totalPages }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => goToSlide(idx)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                Math.floor(currentIndex) === idx
                  ? 'bg-gradient-to-r from-green-500 to-yellow-500 w-6'
                  : 'bg-gray-300 hover:bg-green-400 w-1.5'
              }`}
              aria-label={`Go to set ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;